import { apiSlice } from "../../../app/service/Service";

export const userResetPasswordSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        resetPassword: builder.mutation({
            query : (body)=> ({
                    url: `Account/ResetPassword`,
                    method: "POST",
                    body
                
            })
        }),  
    })
})

export const { useResetPasswordMutation } = apiSlice;

